(function () {
  'use strict';

  function initPartnerPos(root) {
    var dot = root.querySelector('[data-partner-dot]');
    var steps = root.querySelectorAll('[data-journey-step]');
    if (!dot || !steps.length) return;

    function highlightStep(index) {
      steps.forEach(function (step, i) {
        step.classList.toggle('is-highlighted', i === index);
      });
    }

    dot.addEventListener('click', function () {
      var active = dot.classList.toggle('is-active');
      dot.setAttribute('aria-expanded', active ? 'true' : 'false');
      if (active) {
        highlightStep(0);
        var panel = root.closest('.wse-partner-pos-layout');
        if (panel) {
          var journey = panel.querySelector('.wse-partner-journey');
          if (journey) journey.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    });

    steps.forEach(function (step, index) {
      step.addEventListener('mouseenter', function () {
        highlightStep(index);
        dot.classList.add('is-active');
      });
      step.addEventListener('focus', function () {
        highlightStep(index);
        dot.classList.add('is-active');
      });
    });

    root.addEventListener('mouseleave', function () {
      steps.forEach(function (step) {
        step.classList.remove('is-highlighted');
      });
    });
  }

  document.querySelectorAll('[data-wse-partner-pos]').forEach(initPartnerPos);
})();
